import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Navbar from "../components/Navbar";
import PageMeta from "../components/PageMeta";
import Footer from "../components/Footer";
import FloatingFAQ from "../components/FloatingFAQ";

export default function TermsOfService() {
  return (
    <div className="noise-bg">
      <PageMeta title="Terms of Service | Averoan Technologies" />
      <Navbar />
      
      <section className="pt-32 pb-8 relative" data-testid="terms-hero">
        <div className="hero-glow absolute top-0 right-0 opacity-30" />
        <div className="container-main relative z-10">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-sm mb-8 hover:text-[#D4FF00] transition-colors"
            style={{ color: '#A1A1AA' }}
          >
            <ArrowLeft size={16} /> Back to Home
          </Link>
          <h1 
            className="text-4xl md:text-6xl font-bold mb-4"
            style={{ fontFamily: '"Clash Display", sans-serif' }}
          >
            Terms of <span style={{ color: '#D4FF00' }}>Service</span>
          </h1>
          <p style={{ color: '#A1A1AA' }}>Last updated: December 2025</p>
        </div>
      </section>

      <section className="py-12 md:py-20" style={{ background: '#18181B' }}>
        <div className="container-main">
          <div className="max-w-3xl mx-auto space-y-12">
            
            <div>
              <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Clash Display", sans-serif' }}>
                1. Agreement to Terms
              </h2>
              <p className="text-sm leading-relaxed" style={{ color: '#A1A1AA' }}>
                By accessing or using the services provided by Averoan Technologies Inc. ("Company", "we", "us", or "our"), you agree to be bound by these Terms of Service. If you disagree with any part of these terms, you may not access our services.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Clash Display", sans-serif' }}>
                2. Services Description
              </h2>
              <div className="space-y-4 text-sm leading-relaxed" style={{ color: '#A1A1AA' }}>
                <p>Averoan Technologies Inc. provides the following services:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li><strong className="text-white">Web Development:</strong> Custom website design, development, and maintenance</li>
                  <li><strong className="text-white">Custom Software:</strong> Tailored software solutions, CRM systems, and business applications</li>
                  <li><strong className="text-white">Growth Marketing:</strong> SEO optimization, digital marketing, and content strategy</li>
                </ul>
              </div>
            </div>

            <div>
              <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Clash Display", sans-serif' }}>
                3. Project Terms
              </h2>
              <div className="space-y-4 text-sm leading-relaxed" style={{ color: '#A1A1AA' }}>
                <p><strong className="text-white">Proposals & Quotes:</strong> All project proposals and quotes are valid for 30 days unless otherwise specified.</p>
                <p><strong className="text-white">Project Timeline:</strong> Timelines provided are estimates and may vary based on project scope, client feedback turnaround, and unforeseen circumstances.</p>
                <p><strong className="text-white">Revisions:</strong> Each project includes a specified number of revision rounds. Additional revisions may incur extra charges.</p>
                <p><strong className="text-white">Content:</strong> Clients are responsible for providing all necessary content, images, and materials in a timely manner.</p>
              </div>
            </div>

            <div>
              <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Clash Display", sans-serif' }}>
                4. Payment Terms
              </h2>
              <div className="space-y-4 text-sm leading-relaxed" style={{ color: '#A1A1AA' }}>
                <p><strong className="text-white">Deposits:</strong> A deposit of 50% is required before project commencement.</p>
                <p><strong className="text-white">Final Payment:</strong> The remaining balance is due upon project completion, before final files are delivered.</p>
                <p><strong className="text-white">Payment Methods:</strong> We accept bank transfers, credit cards, and other methods as agreed upon.</p>
                <p><strong className="text-white">Late Payments:</strong> Invoices not paid within 14 days may incur a late fee of 2% per month.</p>
              </div>
            </div>

            <div>
              <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Clash Display", sans-serif' }}>
                5. Intellectual Property
              </h2>
              <div className="space-y-4 text-sm leading-relaxed" style={{ color: '#A1A1AA' }}>
                <p><strong className="text-white">Ownership:</strong> Upon full payment, clients receive full ownership rights to the final deliverables created specifically for their project.</p>
                <p><strong className="text-white">Portfolio Rights:</strong> We reserve the right to display completed work in our portfolio and marketing materials unless otherwise agreed in writing.</p>
                <p><strong className="text-white">Third-Party Assets:</strong> Any stock photos, fonts, or third-party tools used in projects are subject to their respective licenses.</p>
              </div>
            </div>

            <div>
              <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Clash Display", sans-serif' }}>
                6. Client Responsibilities
              </h2>
              <div className="space-y-4 text-sm leading-relaxed" style={{ color: '#A1A1AA' }}>
                <p>Clients agree to:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Provide accurate and complete information</li>
                  <li>Respond to requests for feedback within reasonable timeframes</li>
                  <li>Ensure they have rights to all materials provided to us</li>
                  <li>Make payments according to agreed terms</li>
                  <li>Not engage in activities that violate applicable laws</li>
                </ul>
              </div>
            </div>

            <div>
              <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Clash Display", sans-serif' }}>
                7. Limitation of Liability
              </h2>
              <p className="text-sm leading-relaxed" style={{ color: '#A1A1AA' }}>
                To the maximum extent permitted by law, Averoan Technologies Inc. shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly. Our total liability shall not exceed the amount paid for the specific service giving rise to the claim.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Clash Display", sans-serif' }}>
                8. Warranty & Support
              </h2>
              <div className="space-y-4 text-sm leading-relaxed" style={{ color: '#A1A1AA' }}>
                <p><strong className="text-white">Bug Fixes:</strong> We provide 30 days of complimentary bug fixes after project launch for issues directly related to our work.</p>
                <p><strong className="text-white">Ongoing Support:</strong> Extended support and maintenance packages are available at additional cost.</p>
                <p><strong className="text-white">No Guarantee:</strong> While we strive for excellence, we cannot guarantee specific business results such as traffic increases or revenue growth.</p>
              </div>
            </div>

            <div>
              <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Clash Display", sans-serif' }}>
                9. Termination
              </h2>
              <p className="text-sm leading-relaxed" style={{ color: '#A1A1AA' }}>
                Either party may terminate a project with written notice. In case of termination, the client shall pay for all work completed up to the termination date. Deposits are non-refundable unless termination is due to our inability to deliver.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Clash Display", sans-serif' }}>
                10. Contact Information
              </h2>
              <div className="text-sm leading-relaxed" style={{ color: '#A1A1AA' }}>
                <p>For questions about these Terms of Service, please contact us:</p>
                <div className="mt-4 p-6 rounded-xl" style={{ background: '#0F0F11', border: '1px solid rgba(255,255,255,0.1)' }}>
                  <p><strong className="text-white">Averoan Technologies Inc.</strong></p>
                  <p>Email: <a href="mailto:info@averoan.com" className="text-[#D4FF00] hover:underline">info@averoan.com</a></p>
                  <p>Phone: <a href="tel:+17787887273" className="text-[#D4FF00] hover:underline">(778) 788-7273</a></p>
                  <p>Location: Vancouver, BC, Canada</p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      <Footer />
      <FloatingFAQ />
    </div>
  );
}
